import React from 'react';
import { SplitFactory as SplitSdk } from '@splitsoftware/splitio/client';
import { VERSION } from './constants';
// exported for testing purposes
export var __factories = new Map();
// idempotent operation
export function getSplitFactory(config) {
    if (!__factories.has(config)) {
        // SplitSDK is not an idempotent operation
        // @ts-expect-error. 2nd param is not part of type definitions. Used to overwrite the SDK version
        var newFactory = SplitSdk(config, function (modules) {
            modules.settings.version = VERSION;
        });
        newFactory.sharedClientInstances = new Set();
        newFactory.config = config;
        __factories.set(config, newFactory);
    }
    return __factories.get(config);
}
// idempotent operation
export function getSplitSharedClient(factory, key, trafficType) {
    // factory.client is an idempotent operation
    var client = factory.client(key, trafficType);
    if (factory.sharedClientInstances) {
        factory.sharedClientInstances.add(client);
    }
    return client;
}
export function destroySplitFactory(factory) {
    // call destroy of shared clients and main one
    var destroyPromises = [];
    factory.sharedClientInstances.forEach(function (client) { return destroyPromises.push(client.destroy()); });
    destroyPromises.push(factory.client().destroy());
    // remove references to release allocated memory
    factory.sharedClientInstances.clear();
    __factories.delete(factory.config);
    return Promise.all(destroyPromises);
}
export function getStatus(client) {
    var status = client && client.__getStatus();
    var isReady = status ? status.isReady : false;
    var hasTimedout = status ? status.hasTimedout : false;
    return {
        isReady: isReady,
        isReadyFromCache: status ? status.isReadyFromCache : false,
        isTimedout: hasTimedout && !isReady,
        hasTimedout: hasTimedout,
        isDestroyed: status ? status.isDestroyed : false,
    };
}
// Other utils
/**
 * Checks if React.useContext is available, and logs given message if not
 *
 * @param message
 * @returns boolean indicating if React.useContext is available
 */
export function checkHooks(message) {
    if (!React.useContext) {
        console.log(message);
        return false;
    }
    else {
        return true;
    }
}
// Input validation utils that will be replaced eventually
export function validateFeatureFlags(maybeFeatureFlags, listName) {
    if (listName === void 0) { listName = 'split names'; }
    if (Array.isArray(maybeFeatureFlags) && maybeFeatureFlags.length > 0) {
        var validatedArray_1 = [];
        // Remove invalid values
        maybeFeatureFlags.forEach(function (maybeFeatureFlag) {
            var featureFlagName = validateFeatureFlag(maybeFeatureFlag);
            if (featureFlagName)
                validatedArray_1.push(featureFlagName);
        });
        // Strip off duplicated values if we have valid feature flag names then return
        if (validatedArray_1.length)
            return uniq(validatedArray_1);
    }
    console.log("[ERROR] " + listName + " must be a non-empty array.");
    return false;
}
/**
 * Manage client attributes binding
 */
export function initAttributes(client, attributes) {
    if (client && attributes)
        client.setAttributes(attributes);
}
var TRIMMABLE_SPACES_REGEX = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/;
function validateFeatureFlag(maybeFeatureFlag, item) {
    if (item === void 0) { item = 'split name'; }
    if (maybeFeatureFlag == undefined) {
        console.log("[ERROR] you passed a null or undefined " + item + ", " + item + " must be a non-empty string.");
    }
    else if (!isString(maybeFeatureFlag)) {
        console.log("[ERROR] you passed an invalid " + item + ", " + item + " must be a non-empty string.");
    }
    else {
        if (TRIMMABLE_SPACES_REGEX.test(maybeFeatureFlag)) {
            console.log("[WARN] " + item + " \"" + maybeFeatureFlag + "\" has extra whitespace, trimming.");
            maybeFeatureFlag = maybeFeatureFlag.trim();
        }
        if (maybeFeatureFlag.length > 0) {
            return maybeFeatureFlag;
        }
        else {
            console.log("[ERROR] you passed an empty " + item + ", " + item + " must be a non-empty string.");
        }
    }
    return false;
}
/**
 * Removes duplicate items on an array of strings.
 */
function uniq(arr) {
    var seen = {};
    return arr.filter(function (item) {
        return Object.prototype.hasOwnProperty.call(seen, item) ? false : seen[item] = true;
    });
}
/**
 * Checks if a given value is a string.
 */
function isString(val) {
    return typeof val === 'string' || val instanceof String;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@splitsoftware/splitio-react/es/utils.js
// module id = 504
// module chunks = 25